import { Type } from 'class-transformer'
import { RatecardIdentity } from '@app/features/scope-overview/model/ratecard-identity.model'
import { Department } from '@app/features/scoping/models/department.model'
import { Company } from '@core/model/company.model'
import { User } from '@core/model/user.model'

export class RatecardVersion {
  id!: number
  name!: string
  version!: number
  currencyCode!: string
  @Type(() => Date) createdTs!: Date
  @Type(() => Date) updatedTs!: Date
  @Type(() => User) createdBy?: User
  @Type(() => User) updatedBy?: User
  locationCards?: any[]
  @Type(() => RatecardIdentity) identity!: RatecardIdentity
  @Type(() => RatecardIdentity) rateCardIdentity!: RatecardIdentity
  @Type(() => Department) departments!: Department[]
  userPrivilegeRestrictions?: any[]

  getTotalRolesCount() {
    return this.departments.flatMap((d) => d.roles).length
  }

  isCostPlus(): boolean {
    return this.rateCardIdentity.costPlus
  }

  isOwnedByParentOf(company: Company) {
    if (this.rateCardIdentity.companyId) {
      return this.rateCardIdentity.companyId == company.parentCompany?.id
    }
    return undefined
  }

  isPrivilegeRestricted(privilege) {
    return this.userPrivilegeRestrictions.indexOf(privilege) != -1
  }
}
